// extracted by mini-css-extract-plugin
export default {"gradesView":"grades-view_gradesView__+VNdr","notEditable":"grades-view_notEditable__xKcEE"};